export default __webpack_public_path__ + "static/media/track-stand.5d02a1ad.glb";